import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // 左侧菜单栏数据
        menuItems: [

            {
                name: 'statistics', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '首页', // 文本内容
            },
            {
                name: 'home', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '角色管理', // 文本内容
            },
            {
                name: 'jurisdiction', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '权限管理', // 文本内容
            },
            {
                name: 'Notification', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '通知管理', // 文本内容
            },
            {
                name: 'GroupConfig', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '团队管理', // 文本内容
            },
            {
                name: 'Administrator', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '管理员', // 文本内容
            },
            {
                name: 'ExtractList', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '提现申请列表', // 文本内容
            },

            {
                name: 'Product', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '产品列表', // 文本内容
            },
            {
                name: 'Award',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '奖励列表', // 文本内容
            },
            {
                name: 'ProductOrder',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '产品订单', // 文本内容
            }, {
                name: 'ProductUrl',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '产品订单', // 文本内容
            }, {
                name: 'Insurance',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '保险管理', // 文本内容
            }, {
                name: 'SystemArguments',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '系统参数', // 文本内容
            }, {
                name: 'DaKuan',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '线下打款', // 文本内容
            }, {
                name: 'TeamStatistics',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '团队统计', // 文本内容
            },
            {
                name: 'OutsideGroupQueryList',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '群管理', // 文本内容
            }, {
                name: 'OutsideProductQueryList',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '渠道产品', // 文本内容
            }, {
                name: 'OutsideOrderQueryList',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '渠道订单', // 文本内容
            }, {
                name: 'ProductGroupQueryList',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '产品分组', // 文本内容
            },
            {
                name: 'QueryBindProductList',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '产品批量绑定', // 文本内容
            }, {
                name: 'ProductNew',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '产品列表', // 文本内容
            }, {
                name: 'UserGroupQueryList',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '用户组', // 文本内容
            }, {
                name: 'adminStatistics',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '管理员统计', // 文本内容
            },
            {
                name: 'ActivityList',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '活动列表', // 文本内容
            },
            {
                name: 'GiftManagement', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '礼品管理', // 文本内容
            },
            {
                name: 'InformationGift',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '办卡礼品', // 文本内容
            },

            {
                name: 'template', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '群发模板' // 文本内容
            }, {
                name: 'record', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '消息记录' // 文本内容
            },
            {
                name: 'ProductShieldUser',
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '产品屏蔽列表', // 文本内容
            },
            {
                name: 'PopupsList', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '弹窗列表' // 文本内容
            }, {
                name: 'DataRecording', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '数据记录' // 文本内容
            }, {
                name: 'Broadcast', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'md-home', // icon类型
                text: '消息广播' // 文本内容
            },

            // {
            //     size: 18, // icon大小
            //     type: 'md-home', // icon类型
            //     text: '订单明细', // 文本内容
            //     children: [{
            //             name: 'OrderForm',
            //             type: 'ios-grid',
            //             text: '用户产品订单'
            //         },
            //         {
            //             name: 'JuniorOrderForm',
            //             type: 'ios-grid',
            //             text: '用户下级产品订单'
            //         }
            //     ]
            // },
        ],
    },
    mutations: {
        setMenus(state, items) {
            state.menuItems = [...items]
        },
    }
})

export default store